import React, { createContext, useState, useEffect } from "react";

export const VideoPlayerContext = createContext();

export const VideoPlayerProvider = ({ children }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [videoSource, setVideoSource] = useState(null);
  // const [loop, setLoop] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [hasRedirected, setHasRedirected] = useState(false);
  // const [muted, setMuting] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);

// MUTED SAVED TO LOCAL STORAGE
  // Initialize state from localStorage
  const [muted, setMuting] = useState(() => {
    const saved = localStorage.getItem('muted');
    return saved !== null ? JSON.parse(saved) : false;
  });

  // Save to localStorage whenever the state changes
  useEffect(() => {
    localStorage.setItem('muted', JSON.stringify(muted));
  }, [muted]);

// LOOP SAVED TO LOCAL STORAGE
  // Initialize state from localStorage
  const [loop, setLoop] = useState(() => {
    const saved = localStorage.getItem('loop');
    return saved !== null ? JSON.parse(saved) : false;
  });

  // Save to localStorage whenever the state changes
  useEffect(() => {
    localStorage.setItem('loop', JSON.stringify(loop));
  }, [loop]);

  return (
    <VideoPlayerContext.Provider
      value={{
        isPlaying,
        setIsPlaying,
        videoSource,
        setVideoSource,
        loop,
        setLoop,
        currentTime,
        setCurrentTime,
        duration,
        setDuration,
        hasRedirected,
        setHasRedirected,
        muted,
        setMuting,
        isFullscreen,
        setIsFullscreen
      }}
    >
      {children}
    </VideoPlayerContext.Provider>
  );
};
